import { useTranslation } from 'react-i18next';
import PackageStatusBadge from './PackageStatusBadge';
import DropdownMenu from '../../Fundamentals/DropdownMenu/DropdownMenu';
import type { NumberedVersion } from './versionUtils';

interface PackageVersionPickerProps {
    // already numbered, newest first
    versions: NumberedVersion[];
    selectedVersionId: string | undefined;
    onSelectVersion: (versionId: string) => void;
}

const VersionLabel = ({ label, status }: { label: string; status: NumberedVersion['status'] }) => (
    <span className="d-inline-flex align-items-center gap-8">
        <span className="font-weight-600">{label}</span>
        <PackageStatusBadge status={status} />
    </span>
);

const PackageVersionPicker = ({ versions, selectedVersionId, onSelectVersion }: PackageVersionPickerProps) => {
    const { t } = useTranslation();

    const selected = versions.find((version) => version.versionId === selectedVersionId);
    if (selected === undefined) return null;

    return (
        <DropdownMenu
            label={t('packages.version') ?? ''}
            triggerClassName="dropdown-toggle dropdown-field"
            trigger={<VersionLabel label={selected.label} status={selected.status} />}
            items={versions.map((version) => ({
                key: version.versionId ?? version.label,
                label: <VersionLabel label={version.label} status={version.status} />,
                active: version.versionId === selectedVersionId,
                onClick: () => {
                    if (version.versionId !== undefined) onSelectVersion(version.versionId);
                },
            }))}
        />
    );
};

export default PackageVersionPicker;
